export const CAMPAIGN_DAYS = 5;
export const offersMapping = {
  top: {
    offerCount: 2,
  },
  away: {
    offerCount: 2,
  },
  exclusive: {
    offerCount: 2,
  },
};
